import { SaleOrderItem } from '@models';

export const MEASUREMENT_UNIT_PLACEHOLDER = 'No especificado';

/**
 * Unit shown for a product row (UM). Shared by the desktop card, the mobile
 * sheet and the detail page so the three views cannot drift apart.
 */
export function getMeasurementUnit(
  item: Pick<SaleOrderItem, 'productCategoryConfiguration'> | null | undefined,
): string {
  return (
    item?.productCategoryConfiguration?.measurementUnit ??
    MEASUREMENT_UNIT_PLACEHOLDER
  );
}
